import { keepPreviousData, useInfiniteQuery } from '@tanstack/react-query';
import { getScreens, type IScreensReadParams } from 'shared/src/api';
import { useFilterListAtom } from 'shared/src/component/AtomicRenderer/ItemList/FilterList/Provider/filterList/useFilterListAtom';
import { useGetCommonParams } from '../../hooks';

export const useGetScreensInfiniteQuery = (nextToken?: string) => {
  const { screenName: routeScreenName } = useGetCommonParams();
  const {
    filterListAtomValue: { screen_name, ...restFilterListAtomValue },
  } = useFilterListAtom();

  // 웹에서 이전 화면의 stale atom으로 API 호출 방지
  const isAtomSynced = screen_name === routeScreenName;

  return useInfiniteQuery({
    queryKey: [
      'getScreens',
      { ...restFilterListAtomValue, nextToken, screen_name: routeScreenName },
    ],
    queryFn: ({ pageParam }) => {
      const requestParams = {
        ...restFilterListAtomValue,
        next_token: pageParam ?? null,
        screen: routeScreenName,
      } as IScreensReadParams;
      return getScreens(requestParams);
    },
    enabled: routeScreenName !== undefined && isAtomSynced,
    initialPageParam: nextToken ?? null,
    getNextPageParam: lastPage => {
      return lastPage.nextToken || undefined;
    },
    select: data => {
      const components = data.pages.flatMap(page => page.components);
      const formattedData = {
        ...data.pages[data.pages.length - 1],
        components,
      };

      return formattedData;
    },
    placeholderData: keepPreviousData,
  });
};
